import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-left: var(--left-spacing);
  height: calc(100% - 48px);
`;
